// extracted by mini-css-extract-plugin
module.exports = {"sl2v57h":"sl2v57h","w26yazv":"w26yazv","sae4cet":"sae4cet","a1ambr24":"a1ambr24"};